import PreviewControls from "./PreviewControls";

export const DefaultPreviewScreen = ({
  name,
  enableJoin,
  savePreferenceAndJoin,
  isPCVCPreview,
}) => {
  return (
    <div>
      <img
        src="/svgs/yocket-full-logo.svg"
        alt="yocket_logo"
        className="h-6 w-auto lg:h-10 mt-4 lg:mt-0 lg:fixed lg:top-6 lg:left-6"
      />
      <h1 className="text-2xl lg:text-[40px] lg:leading-[52px] text-yocket-neutral-0 font-bold text-center mt-6 max-w-[331px] sm:max-w-none lg:mt-16">
        Dive into the world of studying abroad!
      </h1>
      <div
        className="fixed bottom-8 sm:bottom-12 w-full 
                            flex gap-2.5 items-center justify-center"
      >
        <button
          type="button"
          className="yocket-btn !py-3 !text-base w-[212px] sm:w-[312px]"
          disabled={!name || !enableJoin}
          onClick={savePreferenceAndJoin}
        >
          Join the {isPCVCPreview ? "Call" : "Event"}
        </button>
        <PreviewControls
          enableJoin={enableJoin}
          savePreferenceAndJoin={savePreferenceAndJoin}
        />
      </div>
    </div>
  );
};

export default DefaultPreviewScreen;
